import SubHeading from "@/components/sections/SubHeading";
import React from "react";

interface FeeWaiver {
  _id: string;
  instituteId: string;
  Waiver_Category_Name: string;
  Eligibility_Criteria: string;
  Waiver_Amount_Details: string;
}

interface FeeWaiversProps {
  feeWaivers: FeeWaiver[];
}

const FeeWaivers: React.FC<FeeWaiversProps> = ({ feeWaivers }) => {
  if (!feeWaivers || feeWaivers.length === 0) {
    return null;
  }

  return (
    <div className="py-8">
      <SubHeading align="left" top="Fee Waivers & Scholarships" />

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6">
        {feeWaivers.map((waiver) => (
          <div
            key={waiver._id}
            className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow"
          >
            <div className="bg-[var(--primary)] text-white px-6 py-4">
              <h3 className="text-lg font-semibold">
                {waiver.Waiver_Category_Name}
              </h3>
            </div>

            <div className="p-6 space-y-4">
              <div>
                <p className="text-sm text-gray-600 font-medium mb-2">
                  Eligibility Criteria
                </p>
                <p className="text-gray-900 text-sm leading-relaxed">
                  {waiver.Eligibility_Criteria}
                </p>
              </div>

              <div>
                <p className="text-sm text-gray-600 font-medium mb-2">
                  Waiver Details
                </p>
                <p className="text-gray-900 text-sm leading-relaxed font-medium">
                  {waiver.Waiver_Amount_Details}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 p-4 bg-blue-50 border-l-4 border-blue-500 rounded">
        <p className="text-sm text-gray-700">
          <strong>Note:</strong> Please verify the latest fee waiver information
          and eligibility criteria with the college administration before
          applying.
        </p>
      </div>
    </div>
  );
};

export default FeeWaivers;
